import React, { useCallback } from "react";

import Skeleton from "antd/es/skeleton";
import { useIntl } from "react-intl";

import Color from "@mapmycustomers/shared/enum/Color";
import { Territory } from "@mapmycustomers/shared/types/entity";
import { stopEvents } from "@mapmycustomers/shared/util/browser";
import { Avatar } from "@mapmycustomers/ui";

import UserPreviewCard from "@app/component/UserPreviewCard";
import anyColorToHex from "@app/util/colors/anyColorToHex";

import styles from "./TerritoryListItem.module.scss";

interface Props {
  onClick?: (territory: Territory) => void;
  territory: Territory;
}

const TerritoryListItem: React.FC<Props> = ({ onClick, territory }) => {
  const intl = useIntl();

  const handleClick = useCallback(() => onClick?.(territory), [territory, onClick]);

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.left}>
        <div
          className={styles.dot}
          style={{
            backgroundColor: anyColorToHex(territory.color || Color.BLACK),
          }}
        />
        <div className={styles.details}>
          <div className={styles.header}>
            <div className={styles.name}>{territory.name}</div>
          </div>
          <div className={styles.count}>
            {territory.count === undefined ? (
              <Skeleton.Input active className={styles.skeleton} size="small" />
            ) : (
              intl.formatMessage(
                {
                  id: "map.toolbar.popovers.territories.item.count",
                  defaultMessage:
                    "{count, plural, =0 {No records} one {{count} record} other {{count} records}}",
                  description:
                    "Records in territory count information in Territories popover on the Map page",
                },
                {
                  count: territory.count,
                }
              )
            )}
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <UserPreviewCard userId={territory.user.id}>
          <Avatar
            actionOnHover
            className={styles.avatar}
            onClick={stopEvents}
            user={territory.user}
          />
        </UserPreviewCard>
      </div>
    </div>
  );
};

export default TerritoryListItem;
